import React from 'react'
import { graphql } from 'gatsby'
import style from './button-list.mod.scss'
import { Button } from '@components'

const ButtonList = ({ links }) => {
  return (
    <div className={style['button-list']}>
      <div className={style['button-list__wrapper']}>
        {links?.length > 0 &&
          links.map(link => (
            <Button
              {...link}
              to={link?.link?.path || link.url}
              children={link.displayText}
              key={`button-list-button-${link.id}`}
            />
          ))}
      </div>
    </div>
  )
}

export default ButtonList

export const query = graphql`
  fragment ButtonList on DatoCmsButtonList {
    id
    padding
    background
    links {
      ...Link
    }
    model {
      apiKey
    }
  }
`
